module.exports = __webpack_public_path__ + "static/media/Edit-tb-ico.9700a56c.svg";